import { AddShoppingCartOutlined } from "@mui/icons-material";
import Grid from '@mui/material/Grid';
import { useSnackbar } from "notistack";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
  Box,
  CardActionArea,
  CircularProgress

} from "@mui/material";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart, isItemInCart }) => {
  const { enqueueSnackbar } = useSnackbar();
   return (
    <>   
  <Grid item xs={12} sm={12} md={12} lg={12} key={product._id}>          
    <Card className="card" flexDirection={"column"}>
      <CardActionArea>
     
<CardMedia
          component="img"
          image={product.image}
          alt="green iguana"
        />

      <CardContent>        
        <Typography variant="h7" component="div" sx={{ color: 'text.secondary' }}>
        {product.name}
        </Typography>

        <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: "600" }} paddingY={1}>
        ${product.cost}
        </Typography>
        
      <Box>      
      <Rating
        name="simple-controlled"
        value={product.rating}
        readOnly
        />
      </Box>
      </CardContent>      
      </CardActionArea>

      <CardActions className="card-button">
        <Button size="large" className="button" onClick={()=> {
          if(isItemInCart(product._id)){
            enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.", { variant: "warning" });
          }else{
            handleAddToCart(product._id, 1)
          }
        } }><AddShoppingCartOutlined size={24} color={"white"} />Add To Cart</Button>
      </CardActions>
    </Card>
          </Grid>    

     </>

  
  );
};

export default ProductCard;
